import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getPopoverUtilityClass(slot) {
  return generateUtilityClass('MuiPopover', slot);
}
const popoverClasses = generateUtilityClasses('MuiPopover', ['root', 'paper']);
export default popoverClasses;